import type { TaxRuleListRow } from 'app/shared/api/taxRules/types';
import {
  FETCH_TAX_RULES,
  SET_TAX_RULES,
  TAX_SET_FILTER_NAME,
  TAX_SET_FILTER_CENTRE,
  TAX_SET_FILTER_COUNTRY,
  TAX_SET_FILTER_SPECIFIC_CENTRE,
  TAX_SET_FILTER_START_FROM,
  type TaxFilterCentre,
  type TaxFilterCountry,
} from './actions';

export interface TaxManagerState {
  list: TaxRuleListRow[];
  loading: boolean;
  filterName: string;
  filterCentre: TaxFilterCentre;
  filterCountry: TaxFilterCountry;
  filterSpecificCentre: boolean;
  filterStartDateFrom: string | null;
}

const initialState: TaxManagerState = {
  list: [],
  loading: false,
  filterName: '',
  filterCentre: null,
  filterCountry: null,
  filterSpecificCentre: false,
  filterStartDateFrom: null,
};

export default function taxManagerReducer(state: TaxManagerState = initialState, action: any): TaxManagerState {
  switch (action.type) {
    case FETCH_TAX_RULES:
      return { ...state, loading: true };
    case SET_TAX_RULES:
      return { ...state, loading: false, list: action.payload ?? [] };
    case TAX_SET_FILTER_NAME:
      return { ...state, filterName: action.payload ?? '' };
    case TAX_SET_FILTER_CENTRE:
      return { ...state, filterCentre: action.payload ?? null };
    case TAX_SET_FILTER_COUNTRY:
      return { ...state, filterCountry: action.payload ?? null };
    case TAX_SET_FILTER_SPECIFIC_CENTRE:
      return { ...state, filterSpecificCentre: !!action.payload };
    case TAX_SET_FILTER_START_FROM:
      return { ...state, filterStartDateFrom: action.payload ?? null };
    default:
      return state;
  }
}